export default __webpack_public_path__ + "static/media/volume.ba8ea15f.svg";